import './App.css';
import Banner from './Banner';
import Nav from './Nav';
import requests from './requests';
import Row from './Row'
function App() {
  return (
    <div className="App">
	 <Nav/>
	 <Banner/>
     <Row title="NETFLIX ORIGINALS" isLargeRow fetchUrl={requests.fetchNetflixOriginals} />
	 <Row title="Trending" fetchUrl={requests.fetchTrending} />
	 <Row title="Top Rated" fetchUrl={requests.fetchTopRated} />
	 <Row title="Action Movies" fetchUrl={requests.fetchActionMovies} />
	 <Row title="Comedy Movies" fetchUrl={requests.fetchComedyMovies} />
	 <Row title="Horror Movies" fetchUrl={requests.fetchHorrorMovies} />
	 <Row title="Romance Movies" fetchUrl={requests.fetchRomanceMovies} />
	 <Row title="Documentries" fetchUrl={requests.fetchDocumantaries} />	
    </div>
  );
}

export default App;
